import { CardStatus } from '../enums';

export class PaymentCardDto {
  public paymentCardID: number;
  public cardHoldersName: string;
  public cardType: string;
  public last4Digits: string;
  public expireMonth: number;
  public expireYear: number;
  public cardState: CardStatus;
}
